import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Assets/CSS/company.css';
import bgimg from '../Assets/Images/companybg.jpeg';
import { Link, useLocation } from 'react-router-dom';
import ContactUs from '../sections/home/Contactus';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Dropdown } from 'react-bootstrap';
import { useRef } from "react";

function Companylistpage() {

    const dropdownRef = useRef(null); // Reference to dropdown

    const countries = [
        { value: "AF", label: "Afghanistan" },
        { value: "AL", label: "Albania" },
        { value: "DZ", label: "Algeria" },
        { value: "AD", label: "Andorra" },
        { value: "AO", label: "Angola" },
        { value: "IN", label: "India" },
    ];

    // const [isOpen, setIsOpen] = useState(false);

   
  
    const location = useLocation();
    const initialCountry = location.state?.selectedCountryLabel || countries[0].label;
    const [country, setCountry] = useState(initialCountry);
    // const [selectedCountry, setSelectedCountry] = useState("");
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);



    // const [show, setShow] = useState(false); // Control dropdown visibility

    // const handleToggle = (isOpen) => {
    //     setShow(isOpen); // Track open/close state
    // };

    // const handleCountryChange = (selectedCountry, event) => {
    //     setCountry(selectedCountry);
    //      // Force Bootstrap to close the dropdown
    // if (event) {
    //     event.preventDefault();
    //     event.stopPropagation();
    // }

    // setShow(false);
    // };

    const handleChange = (event) => {
        const selectedCountryLabel = event.target.value; // Get selected country name
        setCountry(selectedCountryLabel);
       
        // setSelectedCountry(event.target.value);
    };


    useEffect(() => {

        const fetchCompanies = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/sellers/company-info`,
                     {
                        params:{countryName:country}
                     });
                
                setCompanies(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching companies:", error);
                setError("Failed to load company data. Please try again later.");
                setLoading(false);
            }
        };
        fetchCompanies();
    }, [country]);

    // const handleCountryChange = (selectedLabel) => {
    //     setCountry(selectedLabel);
    // };

    return (
        <div>
            <div className="company-page">
                <div className="header-section text-white d-flex flex-column justify-content-between">
                    <img src={bgimg} alt="line" className="header-image" />
                    <div className="breadcrumbs">
                        <span>
                            <Link to="/" className="text-decoration-none" style={{ color: 'inherit' }}>
                                <i className="fas fa-home me-1 py-2 ps-4"></i>
                            </Link>
                        </span> &gt; <span>{country}</span>
                    </div>



                    <div className="dropdown-box country-drop">

                        <select
                            id="countrySelect"
                            className="px-5  form-select countryDropDown"
                            style={{
                                color:'white'
                            }}
                            value={country}
                            onChange={handleChange}
                            
                        >
                            {countries.map((item) => (
                                <option key={item.value} value={item.label}
                                style={{fontSize:'15px',color:'#000000'}}
                                >
                                    {item.label}
                                </option>
                            ))}
                        </select>

                        
                    </div>










                    {/* <Dropdown show={show} onToggle={handleToggle}>
                        <Dropdown.Toggle 
                            className="btn rounded-pill" 
                            onClick={() => setShow(!show)} // Toggle dropdown manually
                            style={{ fontSize: "30px", fontWeight: "500", color: "white", textTransform: "uppercase" }}>
                            {country}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {countries.map((item) => (
                                <Dropdown.Item key={item.value}  
                                onClick={(e) => handleCountryChange(item.label, e)}>
                                    {item.label}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown> */}

                    {/* <button
                            className="btn rounded-pill dropdown-toggle"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ fontSize: '30px', fontWeight: '500', color: 'white', textTransform: 'uppercase' }}
                        >
                            {country+"sjasi"}
                        </button> */}
                    {/* <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {countries.map((item) => (
                                <li key={item.value}>
                                    <a
                                        className="dropdown-item"
                                        onClick={() => handleCountryChange(item.label)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {item.label}
                                    </a>
                                </li>
                            ))}
                        </ul> */}

                </div>
                <div className="container mt-4">
                    <div className="d-flex justify-content-between flex-wrap">
                        <p className="company-list-title">List of registered companies:</p>
                        <span className="text-muted">
                            (Showing {loading ? '...' : companies.length} companies)
                        </span>
                    </div>
                    {loading ? (
                        <div className="company-list mt-3">
                            {Array.from({ length: 5 }).map((_, index) => (
                                <div key={index} className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center company-item p-3 mb-3 rounded-custom shadow-sm">
                                    <div className="number-circle me-3"><Skeleton width={20} height={20} /></div>
                                    <div className="company-icon">
                                        <Skeleton circle width={40} height={40} />
                                    </div>
                                    <div className="company-details px-3 flex-grow-1 d-flex justify-content-between align-items-center">
                                        <Skeleton width={150} height={20} />
                                        <Skeleton width={200} height={15} />
                                    </div>
                                    <Skeleton width={100} height={35} />
                                </div>
                            ))}
                        </div>
                    ) : error ? (
                        <p className="text-danger">{error}</p>
                    ) : companies.length === 0 ? (
                        <p className="text-center mt-5">
                            No companies available for the selected country. Please change or select another country.
                        </p>
                    ) : (
                        <div className="company-list mt-3">
                            {companies.map((company, index) => (
                                <div
                                    key={company.userId}
                                    className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center company-item p-3 mb-3 rounded-custom shadow-sm"
                                >
                                    <div className="number-circle me-3">{index + 1}.</div>
                                    <div className="company-icon">
                                        <span className="icon-letter">
                                            {company.sellerFirstName ? company.sellerFirstName.charAt(0).toUpperCase() : 'N/A'}
                                        </span>
                                    </div>
                                    <div className="company-details px-3 flex-grow-1 d-flex justify-content-between align-items-center">
                                        <div className="cname">
                                            {company.sellerFirstName} {company.sellerLastName}
                                        </div>
                                        <div className="subtext">
                                            &bull; {company.yearOfExperiance || 'N/A'} Years Experience &bull;{' '}
                                            {company.sellerCompanyLocation || 'N/A'} &bull; {company.productCount || '0'} Products
                                        </div>
                                    </div>
                                    <Link to={`/companydetail/${company.sellerId}`}>
                                        <button className="btn btn-outline-primary1 rounded-pill mt-2 mt-sm-0">
                                            View Profile
                                        </button>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <ContactUs />
        </div>
    );
}

export default Companylistpage;
